import Badge from '../../../components/Badge/Badge';
import Button from '../../../components/Button/Button';
import Error from '../../../components/Error/Error';
import Loading from '../../../components/Loading/Loading';
import Modal from 'react-native-modal';
import React, { ReactNode, useEffect, useMemo } from 'react';
import Show from '../../../components/Show/Show';
import VideoComponent from '../../../components/Video/VideoComponent';
import { ActivePath } from '../../../components/Cards/ActivePath';
import { AntDesign, Entypo, FontAwesome, MaterialCommunityIcons } from '@expo/vector-icons';
import { BIG_FONT_SIZE_FN, BIG_HORIZONTAL_MARGIN_FN, MARGIN_FN, REGULAR_HORIZONTAL_MARGIN_FN, REGULAR_MARGIN_VERTICAL_FN, SMALL_MARGIN_VERTICAL_FN, TINY_MARGIN_VERTICAL_FN, isWeb } from '../../../config/designSystem/Layout';
import { BOTTOM_SPACING_SCROLLVIEW, SPACING } from '../../../config/designSystem/Spacing';
import { Body2Reg, DesktopH3, ParagraphMBold, ParagraphMRegular, ParagraphSRegular, Subtitle1, Subtitle2 } from '../../../config/designSystem/typography';
import { COLORS, GRADIENTS, ModuleGradient, NEUTRAL_TEXT0, NEUTRAL_TEXT400 } from '../../../config/designSystem/Colors';
import { CREATE_USER_PATH, UPDATE_USER_PATH } from '../../../state/mutations/UserPath';
import { EVENTS_NAMES } from '../../../utils/analytics/eventsNames';
import {  FlatList, ScrollView, TouchableOpacity, View } from 'react-native';
import { GradientFadingText } from '../../../components/Gradients/GradientFadingText';
import { ISession } from '../../../state/stores/Session/SessionModel';
import { LinearGradientLine } from '../../../components/Gradients/LinearGradientLine';
import { ModalOfPath } from '../../../components/Library/ModalOfPath';
import { PathImage } from '../../../components/Cards/PathImage';
import { RFPercentage } from 'react-native-responsive-fontsize';
import { SessionCard } from '../../../components/Library/SessionCard';
import { TopNavigation } from '../../../components/TopNavigation/TopNavigation';
import { addTag } from '../../../utils/onesignal/addTag';
import { addTrigger } from '../../../utils/onesignal/addTrigger';
import { branchingKey, chooseNewPathKey, dashboardKey, dashboardStackKey, libraryKey, libraryStackKey, privateKey, sessionStackKey, settingKey, settingStackKey, visitedPagePathKey } from '../../../constants/routeKeys';
import { captureException } from '@sentry/react-native';
import { concatPath } from '../../../utils/links/concatPath';
import { getLabelByPath } from '../../../utils/labelIter';
import { isNull, isUndefined } from 'lodash';
import { loadString, saveString } from '../../../utils/storage';
import { logAmplitude, setProperty } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { removeIAMClickHandler, setIAMClickHandler } from '../../../utils/onesignal/setIAMClickHandler';
import { router, useFocusEffect, useLocalSearchParams, useSegments } from 'expo-router';
import { showMessage } from 'react-native-flash-message';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useIsConnected } from '../../../hooks/useIsConnected';
import { useIsSmallWeb } from '../../../hooks/ui/useIsSmallWeb';
import { useMutation } from '@apollo/client';
import { useOneSignal } from '../../../components/Root/OneSignalContext';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStores } from '../../../hooks/useStores';
import { useTabBarHeight } from '../../../components/NavigationPanel/TabBarHeightContext';



const Path = observer(() => {
  const rootStore = useStores();

  const labels = rootStore?.language.translate.MOBILE.PATH;
  const allLabels = rootStore?.language.translate; // to be kept (eval)

  const [createUserPathMutation] = useMutation(CREATE_USER_PATH);
  const [updateUserPathMutation] = useMutation(UPDATE_USER_PATH);
  // Local, NOT global: useGlobalSearchParams reports the params of whichever route is
  // focused anywhere in the app, and this screen stays mounted in its tab stack. When
  // the assistance flow navigated to session/branching with { id: <surveyId> }, this
  // screen re-read that id and called fetchPathIfNotExist(surveyId), which is what
  // produced "Can't retrieve item with the ID: <id>, PathService" on the Support tab.
  const params = useLocalSearchParams();

  const [isModalSummaryVisible, setModalSummaryVisible] = React.useState(false);
  const [isModalOfPathVisible, setModalOfPathVisible] = React.useState(false);

  const [summaryPoints, setSummaryPoints] = React.useState<string[]>([]);
  const [pathSummary, setPathSummary] = React.useState<any[]>([]);
  const [publishLanguage, setPublishLanguage] = React.useState(true);
  const {tabBarHeight} = useTabBarHeight();
  const insets = useSafeAreaInsets();

  const programExist = rootStore?.path?.programExist;


  const [title, setTitle] = React.useState('');
  const scrollRef = React.useRef<FlatList | null>(null);

  const [started, setStarted] = React.useState(false);
  const [pause, setPause] = React.useState(false);
  const [complete, setComplete] = React.useState(false);

  const displayButtonBelow = params.displayButtonBelow === 'true'? true: false;

  const alreadyVisited = rootStore?.onboarding?.isVisited(visitedPagePathKey);


  const [descriptionPressed, setDescriptionPressed] = React.useState(isWeb || !started);



  const connected = useIsConnected();
  const id = params.id;



  const path = rootStore?.path.getPath(id as string);
  const sessionIndex = path?.sessionIndex;
  const color = (GRADIENTS.modules[path?.designSystemColor|| 'YELLOW'] as ModuleGradient).base;
  const nbSessionsDone = path?.numberSessions || 0;

  const category = rootStore?.path.getCategory(id as string);


  const sessions = rootStore?.session.getPathSessionSorted(id);
  const sessionsSummary = rootStore?.session?.getSessionSummary(id);
  const averageSesionDuration = rootStore?.session?.getSessionsAverageDuration(id);

  const hasVideo = path?.hasVideo;
  const {isInitialized} = useOneSignal();

  const { height, width } = useAvailableDimensions();
  const segments = useSegments();
  const {hasLateralBar} = useIsSmallWeb();

  const MAX_WIDTH = Math.max(200, Math.min(width, 1000));


  const BUTTON_HEIGHT = 50;
  const BUTTON_MARGIN_VERTICAL = 10;
  const BUTTON_WRAPPER_HEIGHT= BUTTON_HEIGHT + 2*BUTTON_MARGIN_VERTICAL;

  const MARGIN_HORIZONTAL_TEXT = 15;

  const isActive = path?.isActive();


  const goToHome = () => {
    router.navigate(concatPath([privateKey,dashboardStackKey, dashboardKey ],-1) as string);
  };

  const goToLibrary = () => {
    router.navigate(concatPath([privateKey,libraryStackKey, libraryKey ],-1) as string);
  };

  const goBack = () => {
    if(router.canGoBack()) {
      router.back();
    } else {
      if(segments.includes(dashboardStackKey)) {
        goToHome();
      } else {
        goToLibrary();
      }
    }
  };

  const goToSetting = () => {
    router.navigate({
      pathname: concatPath([privateKey, settingStackKey, settingKey],  -1) as string,
      params: {
        notif: encodeURIComponent(true),
        redirectToPath: id,
      }});
  };

  const goToSession= (sessionClickedId: string) => {
    // starting a session here while no path is followed means following
    // this one: make it active right away, so the Today list picks it up
    // (it used to take an explicit "Choose this path" that nobody found)
    if (!programExist && !isActive && path?._id) {
      pathEvent('Program Chosen');
      setActivePathStore();
      rootStore?.user.setActivePath(path._id);
    }
    logAmplitude('Session Started', {
      pathId: path?.humanReadableId,
      sessionId: sessionClickedId,
      from: 'path',
      element_interaction: 'bottom_button'
    });
    router.navigate({
      pathname: concatPath([sessionStackKey,  branchingKey]) as string,
      params: {
        pathId: path?._id,
        sessionId: sessionClickedId,
        fromPath: encodeURIComponent(true),
        fromReckoning: encodeURIComponent(false),
      }});
  };









  useEffect(() => {
    if(isInitialized) {
      const listener = setIAMClickHandler(value => {
        if (value === 'setup_notif') {
          addTag('evolutime','true');
          setProperty({ NotificationActivated: true });
          goToSetting();
        }
      });
      return () => {
        removeIAMClickHandler(listener);
      };
    }
  }, [isInitialized]);


  // fetch path if not exists
  useEffect(() => {
    if (id) {
      rootStore?.path.fetchPathIfNotExist(id);
    }
  }, [id, rootStore?.path, rootStore?.language.name.key]);


  useEffect(() => {
    fetchOneSignalUser(rootStore?.user?.user?._id);
  }, []);

  const fetchOneSignalUser =  () => {
    rootStore?.user?.stat?.fetchOneSignalTags();
  };
  // initialise publish, status and sessions
  useEffect(() => {
    if (!!path && path.status) {
      setStarted(path.status === 'started');
      setPause(path.status === 'pause');
      setComplete(path.status === 'complete');
      // load session info
    }

    if (!!path && path.published && path.published === 'false') {
      setPublishLanguage(false);
    } else {
      setPublishLanguage(true);
    }
  }, [
    path?.published,
    path?.status,
    path?.numberSessions,
    path?.totalNumberSessions,
    path?.language,
  ]);



  // initialize summary, loading, and scroll to right session

  useEffect(() => {
    if (!!path && path?.listItems) {
      let modifiedSummary = [];
      const values = path.listItems.match(/<li>(.*?)<\/li>/g);
      if (values && values.length > 0) {
        modifiedSummary = values?.map((val: string) => val.replace(/<\/?li>/g, ' '));
        setPathSummary(modifiedSummary);
      }
    }
  }

  , [path?.listItems]);

  useEffect(() => {
    if(!!sessions && sessions.length>0 && !!path) {
      if (!!sessions[path.numberSessions] && path.numberSessions < path.totalNumberSessions) {
        rootStore?.session.loadContentOfSession(id, (sessions[path.numberSessions] as any)?._id);
      }


      if (path?.summary) {
        let modifiedSummary = [];
        const values = path.summary.match(/<li>(.*?)<\/li>/g);
        if (values && values.length > 0) {
          modifiedSummary = values?.map((val: string) => val.replace(/<\/?li>/g, ' '));
          setPathSummary(modifiedSummary);
        }
      }

      if (scrollRef && scrollRef?.current && sessions.length > 0 && alreadyVisited) {

        setTimeout(() => {
          scrollRef?.current?.scrollToIndex({
            index: Math.round(Math.min(nbSessionsDone, sessions.length - 1)),
            animated: true,
          });}, 200); // If we do it right away with
      }





    }

  }, [!!sessions, alreadyVisited, sessions.length, nbSessionsDone, started,!!path, path?.language, scrollRef?.current]);








  // check user can reasonably see the path (publish is fine)
  useFocusEffect(() => {
    if (!publishLanguage && !started) {
      goToLibrary();
    }

  });

  const pathEvent = (eventName: string) => {
    logAmplitude(eventName, {
      pathId: path?.humanReadableId,
      fromRecommended: params.fromRecommended,
      moduleId: category?.humanReadableId,
    });
  };

  const onPressFollow = async () => {
    try {

      rootStore?.path.changeStatus(id, 'started');
      setStarted(true);
      if (pause) {
        await updateUserPathMutation({
          variables: {
            input: {
              _id: path?.userPath,
              status: 'started',
            },
          },
        });
      } else {
        await createUserPathMutation({
          variables: { input: { path: id} },
        });
      }
      const nbPathsFollowed =(rootStore?.user?.stat?.number_of_path_started || 0) +1;
      rootStore?.user?.stat?.incrementNumberOfPathStarted();


      if(isInitialized){
        addTag('number_of_path_started',String(nbPathsFollowed));
        addTrigger('path_follow_'+String(nbPathsFollowed), rootStore?.language.name.key);
        addTrigger('first_path_followed', rootStore?.language.name.key);
      }
      pathEvent(EVENTS_NAMES.PATH_STARTED);
    } catch (err) {
      captureException(err);
      const val = getLabelByPath(allLabels, (err as any)?.graphQLErrors[0]?.translationKey);

      showMessage({
        message: val?val: 'Unknown error',
        type: 'danger',
        duration: 5000,
      });
    } finally {
      rootStore?.path.fetchPath(id);

    }
  };

  const onPressUnfollow = async () => {
    rootStore?.path.changeStatus(path?._id, 'complete');
    setPause(true);
    await updateUserPathMutation({
      variables: {
        input: {
          _id: path?.userPath,
          status: 'pause',
        },
      },
    });

    logAmplitude(EVENTS_NAMES.PATH_STOPPED, {
      pathId: path?.humanReadableId,
      moduleId: category?.humanReadableId,
    });

    goToLibrary();

    rootStore?.path.fetchPath(path?._id);
  };

  const onPressContinue = () => {
    const sessionClickedId = (sessions[nbSessionsDone] as any)?._id;
    if(sessionClickedId && path?._id) {
      goToSession(sessionClickedId);
    }
  };

  const goToChooseANewPath = () => {
    router.navigate( {
      pathname: concatPath([chooseNewPathKey], 0) as string,
      params :{
        filterOutId: path?._id
      }
    });
  };

  const onPressSummary = (index: number) => {
    setSummaryPoints(sessionsSummary[index]);
    setModalSummaryVisible(true);
    setTitle(sessions[index]?.title);
  };

  const setActivePath = () => {
    setActivePathStore();
    const programExistAndNotFinished = rootStore?.path?.programExistAndNotFinished;
    const currentProgram = rootStore?.user?.activePath;
    pathEvent('Program Chosen');
    rootStore?.user.setActivePath(path?._id);
    if(programExistAndNotFinished) {
      rootStore?.user?.setNeedCollectFeedbackAfterProgramChanged(true, currentProgram);
    }
    goToHome();
  };

  const setActivePathStore = async () => {
    const activePathString =  await loadString('activePath');
    if(!activePathString) {
      saveString('activePath','true');
    }
  };






  const renderSummary = React.useCallback(() => {
    if (summaryPoints && summaryPoints.length > 0) {
      return summaryPoints.map((sp, idx) => {
        return (
          <View key={idx} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
            <Entypo name="chevron-right" size={18} color={COLORS.brand[500] } />
            <View style={{marginLeft:5, zIndex:1, flex:1}}>
              <ParagraphSRegular
                color={NEUTRAL_TEXT400}
              >
                {sp}
              </ParagraphSRegular>
            </View>
          </View>
        );
      });
    } else {
      return <ParagraphSRegular>{labels?.NO_SUMMARY}</ParagraphSRegular>;
    }
    { /* empty */ }
  }, [summaryPoints]);


  const isSummaryAvailable = pathSummary && pathSummary.length > 0;

  const renderPathSummary = () => {

    return pathSummary.map((item, index) => {
      return (<View key={index} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
        <Entypo name="chevron-right" size={BIG_FONT_SIZE_FN(width)} color={COLORS.brand[500] } />
        <ParagraphMRegular>{item}</ParagraphMRegular>
      </View>);
    });
  };

  const renderItem = React.useCallback(
    ({ item, index }: {item : ISession, index: number}) => {
      if(isNull(sessionIndex) || isUndefined(sessionIndex) || !path) {
        return <></>;
      }
      return (
        <SessionCard  item={item}
          started={started}
          complete={complete}
          index={index}
          sessionIndex={sessionIndex}
          path={path}
          onPressSummary={onPressSummary}
          onPressFollow={onPressFollow}
          isSummaryAvailable={sessionsSummary[index]} />
      );
    },
    [sessions.length,!path, sessionIndex ,onPressFollow, onPressSummary, path?.status, started,complete,  width,rootStore?.language.name.key],
  );



  const modalSummary = () => {
    return (
      <Modal isVisible={isModalSummaryVisible}>
        <View style={{ backgroundColor: 'white', borderRadius: 40, padding: 20 }}>
          <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
            <Subtitle2 color="black">
              {labels?.TITLE_SUMMARY_BEFORE + title + labels?.TITLE_SUMMARY_AFTER}
            </Subtitle2>
          </View>
          <ScrollView style={{ maxHeight: RFPercentage(60) }}>{renderSummary()}</ScrollView>
          <View style={{ justifyContent: 'space-around', alignItems: 'center', marginTop: 20 }}>
            <Button color={NEUTRAL_TEXT0}  onPress={() => {
              setModalSummaryVisible(false);
            }}
            label={labels?.SUMMARY_BUTTON}/>

          </View>
        </View>
      </Modal>
    );
  };





  const renderStat= (icon: ReactNode, label: string, withRightDot: boolean) => {
    const SIZE_ICON_CHALLENGE=16;
    return(<View style={{flexDirection:'row', marginLeft: REGULAR_HORIZONTAL_MARGIN_FN(width), alignItems:'center'}}>
      <View style={{flexDirection:'row', marginRight:REGULAR_HORIZONTAL_MARGIN_FN(width),  alignItems:'center'}}>
        <View style={{marginRight: 5}}>
          {icon}
        </View>
        <Body2Reg color={COLORS.content.primary}>
          {label}
        </Body2Reg>

      </View>
      {withRightDot? <Entypo name='dot-single' size={SIZE_ICON_CHALLENGE} color='black' />: null}
    </View>);
  };



  const renderTitle = () => {
    return (<View
      style={{
        alignItems: 'center',
        marginBottom: SMALL_MARGIN_VERTICAL_FN(height),
        marginLeft: MARGIN_FN(width),
      }}
    >
      <DesktopH3>
        {!!path && path.title}
      </DesktopH3>
    </View>);
  };

  const renderStats= () => {
    return(<View>
      <View style={{flexDirection:'row', alignItems: 'center', justifyContent:'center'}}>
        {sessions.length>0 && (<>{renderStat(
          <MaterialCommunityIcons name="stairs" size={16} color='black' />,
          sessions.length+ ' ' + (sessions.length<=1?labels?.SESSION_SINGULAR:labels?.SESSION_PLURAL),
          true
        )}</>)}
        {averageSesionDuration>0 && (<>{renderStat(
          <AntDesign name="clock-circle" size={16} color='black' />,
          averageSesionDuration+ ' ' + labels?.MINUTES,
          false
        )}</>)}
      </View>
    </View>);
  };

  const headerComponent = () => {
    const HEIGHT_IMAGE = 127/390*MAX_WIDTH;
    return (
      <>
        <View
          style={[
            {
              width: MAX_WIDTH,

            },
          ]}
        >
          <PathImage id={id as string} width={MAX_WIDTH} height={HEIGHT_IMAGE} >

            <TopNavigation style={{position:'absolute', width:MAX_WIDTH }}
              topPosition={0.15*HEIGHT_IMAGE}
              horizontalPosition={0.2*HEIGHT_IMAGE}
              onPressLeft={goBack}
              withHeaderRight={!displayButtonBelow}
              headerRightIcon={isActive? 'settings': 'dots'}
              onPressRight={() => {
                setModalOfPathVisible(true);
              }}
              onboarding={!alreadyVisited && isActive && !displayButtonBelow}
              onLeaveOnboarding={() => {
                rootStore?.onboarding?.setVisitedPages(visitedPagePathKey);
              }}
              labelOnboarding={labels?.ONBOARDING}
            />


          </PathImage>
          <View  style={{ rowGap: SPACING['sp-24']}}>
            <View>
              <View style={{marginTop: 10, alignItems:'center'}} >
                <Badge leftColor={color.left} rightColor={color.right} label={category?.shortTitle} />
              </View>
              <View style={{marginVertical: SPACING['sp-16']}}>
                {renderTitle()}
                {renderStats()}
              </View>
            </View>
            <View style={{justifyContent:'center', alignItems:'center'}} >
              <LinearGradientLine leftColor={color.left} rightColor={color.right} width={85} />
            </View>
            <Show when={isActive}>
              <View style={{justifyContent:'center', alignItems:'center'}} >
                <ActivePath />
              </View>
            </Show>

          </View>
        </View>

      </>

    );
  };

  const headerComponentMemo = useMemo(() => {
    return headerComponent();
  },[MAX_WIDTH,
    isModalOfPathVisible,
    started,
    alreadyVisited, category?.title, color, height, path?.image,category?.shortTitle, width, isActive,averageSesionDuration, sessions.length]);




  const MARGIN_TOP_DESC = TINY_MARGIN_VERTICAL_FN(height);

  const renderGrayRectangle = () =>{
    return (<View style={{height:6, backgroundColor:'lightgray', marginVertical: 20}} ></View>);
  };

  const renderOverViewOfSessions = () =>{
    return (<View style={{marginBottom:20, alignItems:'center'}}>
      <Subtitle1>{labels?.OVERVIEW_OF_SESSIONS}</Subtitle1>
    </View>);
  };

  const renderLongDescription = () => {
    return(
      <View style={{marginVertical: MARGIN_TOP_DESC}}>
        <View
          style={{ marginHorizontal: 2 * MARGIN_HORIZONTAL_TEXT }}
        >
          <ParagraphMRegular>
            {!!path && path.longDescription}
          </ParagraphMRegular>
        </View>
      </View>
    );
  };

  const renderWhatYouWillLearn = () => {
    return (isSummaryAvailable && (
      <>
        <View style={{marginVertical: MARGIN_TOP_DESC, marginHorizontal: 2 * MARGIN_HORIZONTAL_TEXT }}>
          {renderSubTitle(labels?.SUBTITLE_VIDEOS)}
          <View style={{  paddingTop: 10, paddingBottom: 20 }}>
            <View style={{ maxHeight: RFPercentage(60) }}>{renderPathSummary()}</View>
          </View>
        </View>
      </>)
    );
  };

  const renderDrawer= (label: string, icon: ReactNode, onPress: () => void, marginTop: number) => {
    return(
      <TouchableOpacity onPress={onPress} style={{flexDirection:'row', justifyContent:'center', alignItems:'center', marginTop}}>
        {!!icon && (
          <View style={{marginRight:10}}>
            {icon}
          </View>)
        }
        <ParagraphMBold>{label}</ParagraphMBold>
      </TouchableOpacity>
    );
  };

  const renderDrawerWrapper = (isOpen: boolean) => {
    if(isWeb) {
      return (<></>);
    }
    if(isOpen) {
      return(<>{
        renderDrawer(labels?.HIDE_DESCRIPTION,
          <FontAwesome name='chevron-up' />,
          () => {setDescriptionPressed(false);},
          REGULAR_MARGIN_VERTICAL_FN(height))}
      </>);
    } else {
      return(<>{
        renderDrawer(labels?.READ_DESCRIPTION,
          <FontAwesome name='chevron-down' />,
          () => {setDescriptionPressed(true);},
          0)}
      </>);
    }
  };



  const renderExtraPathInfo = () => {
    const MARGIN_TOP = REGULAR_MARGIN_VERTICAL_FN(height);
    return(
      <View  style={{ width:MAX_WIDTH, justifyContent:'center', marginTop: MARGIN_TOP}} >
        {descriptionPressed?(
          <>
            {renderLongDescription()}
            {renderWhatYouWillLearn()}
            {hasVideo && <View style={{  justifyContent: 'center', alignItems: 'center' }}>
              <VideoComponent color={COLORS.brand[500] } source={path?.video} widthVideo={MAX_WIDTH} title={''} paddingVideo={2 * MARGIN_HORIZONTAL_TEXT}
                setPositionMillis={()=> {}} setPositionPercent={()=> {}}/>
            </View>}
          </>):
          (<>
            <View style={[!isWeb && {maxHeight:80}]}>
              <GradientFadingText gradient={{
                left:'black',
                right: 'transparent',
                orientationAngle: 180
              }}>
                {renderLongDescription()}
              </GradientFadingText>
            </View>
          </>)}
        {renderDrawerWrapper(descriptionPressed)}
        {renderGrayRectangle()}
        {renderOverViewOfSessions()}
      </View>
    );
  };



  const renderExtraPathInfoMemo = React.useMemo(() => { return renderExtraPathInfo();}, [descriptionPressed, hasVideo, height, isWeb, path?.video, path?.longDescription, path?.summary]);

  const renderSubTitle = (label: string) => {
    return(
      <View style={{paddingTop:10}}>
        <Subtitle1>{label}</Subtitle1>
      </View>
    );
  };




  const buttonEnd = (label: string, onPress: () => void) => {
    const MARGIN_HORIZONTAL = BIG_HORIZONTAL_MARGIN_FN(width);
    const WIDTH_BUTTON = MAX_WIDTH - 2 * MARGIN_HORIZONTAL;
    return (
      <View style={{alignSelf:'center', alignItems:'center', justifyContent:'center', zIndex:2}} >
        <Button onPress={onPress} color={NEUTRAL_TEXT0}
          label={label} width={WIDTH_BUTTON} height={BUTTON_HEIGHT}
          paddingVertical={0}
          marginBottom={BUTTON_MARGIN_VERTICAL}
          marginTop={BUTTON_MARGIN_VERTICAL} />
      </View>
    );
  };

  // the footer button: continue the active path, or make this one active.
  // A path that is not the active one ALWAYS offers "Choose this path" —
  // from the library it used to show nothing when another path was active,
  // and tapping a session played it without ever activating the path
  const  getButtonEndLabel = (config: {isActive?: boolean}) => {
    if(config.isActive) {
      return labels?.CONTINUE_MY_PROGRAM;
    }
    return labels?.CHOOSE_THIS_PATH || labels?.SELECT_AS_PROGRAM || 'Choose this path';
  };

  const  getButtonEndCallback = (config: {isActive?: boolean}) => {
    if(config.isActive) {
      return onPressContinue;
    }
    return setActivePath;
  };

  const renderFooterButton = () => {
    const config =  {isActive};
    const buttonEndLabel = getButtonEndLabel(config);
    const buttonEndCallback = getButtonEndCallback(config);
    return(
      <View style={{
        height: BUTTON_WRAPPER_HEIGHT, // Fixed height for the button container
        justifyContent: 'center',
        alignItems: 'center',
        // marginBottom, not `bottom`: this view is position:'relative', so `bottom`
        // shifts it up visually WITHOUT reserving the space, dropping the button on
        // top of the sessions list. marginBottom actually shortens the list area.
        marginBottom: hasLateralBar?0:tabBarHeight,
      }}>
        <View style={{
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center'}}
        >
          {buttonEnd(buttonEndLabel, buttonEndCallback)}
        </View>
      </View>
    );
  };


  if (!path) {
    return <Loading withLabel={false} />;
  }

  if (rootStore?.path.status === 'error') {
    return <Error network={!connected} labels={rootStore?.language.translate.MOBILE?.ERROR} />;
  }

  const modalOfPath= () => {
    return(<ModalOfPath
      isVisible={isModalOfPathVisible}
      isActive={!!isActive}
      started={started}
      onPressUnfollow={onPressUnfollow}
      onDismiss={() => {setModalOfPathVisible(false);}}
      goToChooseANewPath={goToChooseANewPath}
      setActivePath={setActivePath}
    />);
  };

  const renderMainContent = () => {


    return (
      <View style={{flex: 1}}>
        <View style={{flex: 1}}>
          <FlatList
            ref={scrollRef}
            initialScrollIndex={0}
            horizontal={false}
            onScrollToIndexFailed={info => {
              const wait = new Promise(resolve => setTimeout(resolve, 200));
              wait.then(() => {
                if(alreadyVisited){
                  scrollRef.current?.scrollToIndex({ index: info.index, animated: true });
                }
              });
            }}
            ListHeaderComponent={() => {
              return (
                <View >
                  {headerComponentMemo}
                  {renderExtraPathInfo()}

                </View>
              );
            }}
            ListEmptyComponent={() => {
              return (
                <Loading withLabel={false} />
              );
            }}
            data={sessions}
            keyExtractor={item => item._id}
            renderItem={renderItem}
            contentContainerStyle={{ paddingBottom: BOTTOM_SPACING_SCROLLVIEW }}
          />
        </View>

        {renderFooterButton()}

      </View>
    );
  };


  return <>
    {modalSummary()}
    {modalOfPath()}
    <View  style={[{ marginTop: insets.top,  maxWidth: MAX_WIDTH, alignSelf: 'center', flex:1, overflow: 'hidden' }]}>{renderMainContent()}</View>
  </>;
});

export default Path;